import { Trans } from "@lingui/react/macro";
import type { ReactNode } from "react";

export function scopeLabel(restricted: boolean | undefined): ReactNode {
    return restricted ? <Trans>Restricted</Trans> : <Trans>Global</Trans>;
}

/** @param billingAccountName Set to `null` if billing account information is not available. `undefined` if Global scope. */
export function impersonationLabel(billingAccountName: string | null | undefined) {
    return billingAccountName ? (
        billingAccountName
    ) : billingAccountName === null ? (
        <i>
            <Trans>Unknown billing account</Trans>
        </i>
    ) : (
        <i>{scopeLabel(false)}</i>
    );
}
